/**
 * Collab's brief status
 * @enum {string} BriefStatus - The status enum.
 * @property {string} archived - The archived status.
 * @property {string} draft - The draft status.
 * @property {string} published - The published status.
 */
export enum BriefStatus {
  archived = "archived",
  draft = "draft",
  published = "published",
}

export interface BriefProgress {
  filled_slots_count: number
  total_slots: number
  percent: number
  almost_there: boolean
  total_suggestions_count: number
}

export interface ContributorUser {
  id: number
  display_name: string
  slug: string | null
  has_public_profile: boolean
  avatar_url: string | null
  tagline: string | null
  pronouns: string | null
}

export interface BriefContributor {
  id: number
  role: string
  featured: boolean
  user: ContributorUser | null
  display_name: string
}

export const TRACK_PROMPT_CONTENT_TYPES = [
  "audio",
  "video",
  "article",
  "photo",
] as const
export type TrackPromptContentType = (typeof TRACK_PROMPT_CONTENT_TYPES)[number]

export const TRACK_PROMPT_CURATION_STATES = [
  "pending",
  "locked",
  "filled",
] as const
export type TrackPromptCurationState =
  (typeof TRACK_PROMPT_CURATION_STATES)[number]

export interface TrackPromptSummary {
  id: number
  title: string
  guidance: string | null
  content_type: TrackPromptContentType
  curation_state: TrackPromptCurationState
  position: number
  slot_state: "pending" | "filled"
  suggestions_count: number
  deleted_at: string | null
}

export interface EditorialStrategySummary {
  id: number
  title: string
  slug: string
}
